import React, { FC } from 'react'
import { Chip, Typography } from '@mui/material'

import { checkIsMobile } from '../../utils/agent'
import { PreferenceList } from './contantsAndType'

interface ScheduleTourPreferenceProps {
  selectedPreferences: string[]
  onChange: (preferences: string[]) => void
}

const isMobile = checkIsMobile()

const ScheduleTourPreference: FC<ScheduleTourPreferenceProps> = props => {
  const { selectedPreferences, onChange } = props

  const onClickItem = (item: string) => {
    if (selectedPreferences.includes(item)) {
      onChange(selectedPreferences.filter(i => i !== item))
    } else {
      onChange([...selectedPreferences, item])
    }
  }
  return (
    <>
      <div className="w-full px-5 py-4 lg:pt-12">
        <Typography className="!font-Averta6  !text-lg !text-[#181414]">
          Select your preferences 👀 {!isMobile ? <span className="!text-[#75798D] !mt-2 !text-sm !font-Averta4">Optional</span> : null}
        </Typography>
        {isMobile && <Typography className="!text-[#75798D] !mt-2 !text-sm !font-Averta4">Optional</Typography>}
      </div>
      <div className="w-full px-5 py-4 grid grid-cols-2 gap-y-3 gap-x-4">
        {PreferenceList.map(item => (
          <Chip
            onClick={() => onClickItem(item?.label)}
            className={`${
              selectedPreferences.includes(item?.label) ? '!border-[#050A22] !bg-[#F7F9FC]' : '!border-[#E0E2EF]'
            } !font-Averta4 !text-sm border rounded-[50px]  lg:!px-4 lg:!py-1.5 lg:!h-auto`}
            label={<span className="font-Averta4 text-sm leading-6">{item?.label}</span>}
            key={item?.label}
            variant="outlined"
          />
        ))}
      </div>
    </>
  )
}

export default ScheduleTourPreference
